<script setup lang="ts">
import { IonButton } from '@ionic/vue';

defineProps<{
  type?: 'button' | 'reset' | 'submit';
  color?: 'primary' | 'danger' | 'light' | 'medium' | 'cyan' | 'dark' | 'white';
  size?: 'large' | 'small' | 'default';
  disabled?: boolean;
}>();
</script>

<template>
  <IonButton
    v-bind="$attrs"
    fill="clear"
    :color="color || 'primary'"
    :size="size || 'default'"
    :type="type"
    :disabled="disabled"
  >
    <slot></slot>
  </IonButton>
</template>

<style scoped>
ion-button {
  font-weight: 500;
}
</style>
